var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriverMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.51573,
    y: 1.50695,
    width: 31,
    height: 31,
    rx: 15.5,
    transform: "rotate(-1.83218 0.51573 1.50695)",
    fill: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2087 23.1448C10.1191 23.0481 10.0602 22.927 10.0394 22.7968C10.0186 22.6666 10.0369 22.5332 10.0919 22.4134L15.7051 10.2277C15.7569 10.1151 15.839 10.0191 15.9422 9.95053C16.0455 9.88196 16.1658 9.84353 16.2897 9.83957C16.4136 9.83561 16.5361 9.86626 16.6436 9.92809C16.751 9.98992 16.8391 10.0805 16.8979 10.1896L23.2785 21.9916C23.3412 22.1076 23.3682 22.2397 23.3559 22.371C23.3436 22.5023 23.2926 22.627 23.2094 22.7294C23.1262 22.8317 23.0145 22.9071 22.8885 22.9459C22.7624 22.9848 22.6277 22.9854 22.5013 22.9476L17.3266 21.4043L17.2118 17.8148C17.2062 17.6381 17.1305 17.4708 17.0016 17.3499C16.8726 17.2289 16.7009 17.1641 16.5242 17.1698C16.3475 17.1754 16.1802 17.2511 16.0593 17.38C15.9383 17.509 15.8735 17.6807 15.8792 17.8574L15.994 21.4469L10.9286 23.3185C10.8049 23.364 10.6705 23.3719 10.5424 23.3411C10.4143 23.3103 10.2981 23.2415 10.2087 23.1448Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.51573,
    y: 1.50695,
    width: 31,
    height: 31,
    rx: 15.5,
    transform: "rotate(-1.83218 0.51573 1.50695)",
    stroke: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverMarker);
export default __webpack_public_path__ + "static/media/driver-marker.050a538383fcf10015c601e43b70ab0d.svg";
export { ForwardRef as ReactComponent };